// extracted by mini-css-extract-plugin
module.exports = {"page":"qA-z","cartModal":"rA-z","checkout":"sA-z","placeholder":"tA-z","account":"uA-z"};